import { selectors } from './config';
import CoreEvents from '../../events';

export default class Vehicle {
  stockId;
  cardHtml;
  previewCard;

  constructor(stockId, cardHtml = '') {
    this.stockId = stockId;
    this.cardHtml = cardHtml;
    this.previewCard = this.#buildPreviewCard();
  }

  toObject() {
    const { stockId, cardHtml } = this;

    return {
      cardHtml,
      stockId,
    };
  }

  #buildPreviewCard() {
    const parser = new DOMParser();
    const tempDom = parser.parseFromString(this.cardHtml, 'text/html');
    const cardEl = tempDom.body.firstElementChild;
    const removeButton = cardEl.querySelector(selectors.removeButton);

    removeButton.addEventListener('click', () => {
      const event = CoreEvents.VehicleRemoved(this.stockId);

      window.dispatchEvent(event);
    });

    return cardEl;
  }
}
